import {getPhoneNumber} from "./common";

export default {
  init() {


    var site_dicount_1 = $('.sf-field-post-meta-site_discount_price .sf-meta-range label:first-child input').val();
    var site_dicount_2 = $('.sf-field-post-meta-site_discount_price .sf-meta-range label:nth-child(3) input').val();
    var year_param1 = $('.sf-field-post-meta-prod_year .sf-meta-range label:first-child input').val();
    var year_param2 = $('.sf-field-post-meta-prod_year .sf-meta-range label:nth-child(3) input').val();
    var tachometer_param_1 = $('.sf-field-post-meta-tachometer_stat .sf-meta-range label:first-child input').val();
    var tachometer_param_2 = $('.sf-field-post-meta-tachometer_stat .sf-meta-range label:nth-child(3) input').val();

    var compare_filtre = [];

    const metaData = [
      //-------- ONE PARAMS
      {//0 carType
        title : "פרמטר#עסקה ממגוון יצרנים ודגמים - לובינסקי טרייד",
        description : "בחרו פרמטר#עסקה ממגוון יצרנים ודגמים ותיהנו ממחירים משתלמים ותנאים אטרקטיביים במיוחד. היכנסו לקטלוג הרכבים."
      },
      {//1 carSegment
        title : "רכבי פרמטר#הרכב חדשים או מיד ראשונה למכירה - לובינסקי טרייד",
        description : "בחרו רכב פרמטר#הרכב ממגוון יצרנים ודגמים ותיהנו ממחירים משתלמים ותנאים אטרקטיביים במיוחד. היכנסו לקטלוג הרכבים."
      },
      {//2 carMarket
        title : "מגוון רכבי פרמטר#יצרן חדשים או מיד ראשונה למכירה - לובינסקי טרייד",
        description : "מגוון דגמי פרמטר#יצרן חדשים או מיד ראשונה מחכים לכם באתר לובינסקי טרייד. היכנסו לקטלוג הרכבים."
      },
      {//3 carYear
        title : "מגוון דגמי פרמטר#שנה חדשים או מיד ראשונה למכירה - לובינסקי טרייד",
        description : "דגמי פרמטר#שנה חדשים או מיד ראשונה של מבחר יצרנים מובילים מחכים לכם באתר לובינסקי טרייד. היכנסו לקטלוג הרכבים."
      },
      //-------- TWO PARAMS
      {//4 carType && carSegment
        title : "פרמטר#עסקה מסוג פרמטר#הרכב למכירה - לובינסקי טרייד",
        description : "בחרו פרמטר#עסקה מסוג פרמטר#הרכב ממבחר יצרנים ודגמים ותיהנו ממחירים משתלמים ותנאים אטרקטיביים במיוחד. היכנסו לקטלוג הרכבים."
      },
      {//5 carType && carMarket
        title : "פרמטר#עסקה של פרמטר#יצרן למכירה ממגוון דגמים - לובינסקי טרייד",
        description : "בחרו פרמטר#עסקה של פרמטר#יצרן ממבחר דגמים ותיהנו ממחירים משתלמים ותנאים אטרקטיביים במיוחד. היכנסו לקטלוג הרכבים."
      },
      {//06 carType && carYear
        title : "פרמטר#עסקה ממגוון דגמי פרמטר#שנה למכירה - לובינסקי טרייד",
        description : "בחרו פרמטר#עסקה ממגוון דגמי פרמטר#שנה ותיהנו ממחירים משתלמים ותנאים אטרקטיביים במיוחד. היכנסו לקטלוג הרכבים."
      },
      {//07 carSegment && carMarket
        title : "רכבי פרמטר#יצרן חדשים או מיד ראשונה מסוג פרמטר#הרכב למכירה - לובינסקי טרייד",
        description : "מגוון רכבי פרמטר#יצרן חדשים או מיד ראשונה מסוג פרמטר#הרכב מחכים לכם באתר לובינסקי טרייד. היכנסו לקטלוג הרכבים. "
      },
      {//08 carSegment && carYear
        title : "רכבי פרמטר#הרכב מדגמי פרמטר#שנה ממבחר יצרנים למכירה - לובינסקי טרייד",
        description : "רכבי פרמטר#הרכב מדגמי פרמטר#שנה ממבחר יצרנים מחכים לכם באתר לובינסקי טרייד. היכנסו לקטלוג הרכבים. "
      },
      {//09 carMarket && carYear
        title : "מבחר רכבי פרמטר#יצרן מדגמי פרמטר#שנה למכירה - לובינסקי טרייד ",
        description : "מבחר רכבי פרמטר#יצרן מדגמי פרמטר#שנה חדשים או מיד ראשונה מחכים לכם עכשיו באתר לובינסקי טרייד. היכנסו עכשיו."
      },
      //-------- THREE PARAMS
      {//10 carType && carSegment && carMarket
        title : "פרמטר#עסקה מסוג פרמטר#הרכב של פרמטר#יצרן למכירה - לובינסקי טרייד",
        description : "בחרו פרמטר#עסקה מסוג פרמטר#הרכב של פרמטר#יצרן ותיהנו ממחירים משתלמים ותנאים אטרקטיביים במיוחד. היכנסו עכשיו. "
      },
      {//11 carType && carSegment && carYear
        title : "פרמטר#עסקה מסוג פרמטר#הרכב מדגמי פרמטר#שנה למכירה -לובינסקי טרייד",
        description : "בחרו פרמטר#עסקה מסוג פרמטר#הרכב מדגמי פרמטר#שנה ותיהנו ממחירים משתלמים ותנאים אטרקטיביים במיוחד. היכנסו עכשיו. "
      },
      {//12 carType && carMarket && carYear new
        title : "פרמטר#עסקה של פרמטר#יצרן  מדגמי פרמטר#שנה למכירה - לובינסקי טרייד",
        description : "בחרו פרמטר#עסקה של פרמטר#יצרן מדגמי פרמטר#שנה ותיהנו ממחירים משתלמים ותנאים אטרקטיביים במיוחד. היכנסו עכשיו. "
      },
      {//13 carSegment && carMarket && carYear
        title : "רכבים מסוג פרמטר#הרכב של פרמטר#יצרן מדגמי פרמטר#שנה למכירה - לובינסקי טרייד",
        description : "בחרו רכב מסוג פרמטר#הרכב של פרמטר#יצרן מדגמי פרמטר#שנה ותיהנו ממחירים משתלמים ותנאים אטרקטיביים במיוחד. היכנסו עכשיו. "
      },
      //-------- FOUR PARAMS
      {//14 carType && carSegment && carMarket && carYear
        title : "פרמטר#עסקה מסוג פרמטר#הרכב של פרמטר#יצרן מדגמי פרמטר#שנה למכירה - לובינסקי טרייד",
        description : "בחרו פרמטר#עסקה מסוג פרמטר#הרכב של פרמטר#יצרן מדגמי פרמטר#שנה ותיהנו ממחירים משתלמים ותנאים אטרקטיביים במיוחד. היכנסו עכשיו. "
      }
    ]

    function getParameterByName(name, url = window.location.href)
    {
      name = name.replace(/[\[\]]/g, '\\$&');
      var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
      if (!results) {
        return null;
      }
      if (!results[2]) {
        return '';
      }
      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }


    function marketClicked(){
      jQuery(".sf-field-taxonomy-car_market_taxonomy ul li").each(function() {
        jQuery(this).find("input").click(function () {

          var marketName = jQuery(this).parent().find("label").text();
          var isChecked = jQuery(this).prop("checked");

          jQuery(".sf-field-taxonomy-car_model_taxonomy ul li").each(function() {
            if(!isChecked && jQuery(this).find("input").prop("checked") == true && jQuery(this).find("label").text().includes(marketName)){
              jQuery(this).find("input").prop('checked', false).trigger('change');
            }
            if(isChecked && jQuery(this).find("input").prop("checked") == true && !jQuery(this).find("label").text().includes(marketName)){
              jQuery(this).find("input").prop('checked', false).trigger('change');
            }
          });

        });
      });
    }

    function appendModel() {
      const selectedModelsContainer = jQuery(".selected-model-container");
      const modelElements = jQuery(".sf-field-taxonomy-car_model_taxonomy ul li");
  
      modelElements.each(function() {
          const modelElement = jQuery(this);
          const modelLabel = modelElement.find("label");
          const modelInput = modelElement.find("input");
          const modelId = modelInput.attr('id');
          const isSelected = modelElement.hasClass('sf-option-active');
          const existingModel = selectedModelsContainer.find(`#${modelId}`);
  
          if (isSelected && existingModel.length === 0) {
              selectedModelsContainer.append(
                  `<div id="${modelId}" class="selected-model-card">
                      <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" fill="none" viewBox="0 0 16 16">
                          <circle cx="8" cy="8" r="8" fill="#D01000"/>
                          <path stroke="#fff" stroke-linecap="round" stroke-linejoin="bevel" d="M5.332 4.8l5.333 6.4M5.332 4.8l5.333 6.4M10.664 4.8l-5.333 6.4m5.333-6.4l-5.333 6.4"/>
                      </svg>
                      <p class="selected-model">${modelLabel.text()}</p>
                  </div>`
              );
          } else if (existingModel.length) {
              existingModel.remove();
          }
      });
  
      selectedModelClicked();
  }
  

    function selectedModelClicked(){
      jQuery(".selected-model-container .selected-model-card svg").each(function() {
        jQuery(this).click(function (){
          let clickedId = jQuery(this).parent().attr('id');
          jQuery(".sf-field-taxonomy-car_model_taxonomy ul li").each(function() {
            if(jQuery(this).find("input").attr('id') == clickedId){
              jQuery(this).find("input").prop('checked', false).trigger('change');
            }
          });
        });
      });
    }

    appendModel();
    marketClicked();

    $(document).on("sf:ajaxfinish", ".searchandfilter", function () {
      $('.filters_cars form > ul > li').each(function () {
        $(this).children('ul').children('li').each(function () {
          if ($(this).hasClass('sf-option-active')) {
            $(this).parent().siblings('h4').addClass('active-filtre');
            $(this).parent().show();
          }
        });
      });

      checkParamsFilter();
      appendModel();
      marketClicked();

      if ((window.location.search) == `?_sfm_site_discount_price=20000+250000&_sfm_prod_year=2006+2021&_sfm_tachometer_stat=0+250000`) {
        $('.filters_cars .header_filtre .part_filtre_one a').css('color', '#c0c0c0');
      } else {
        $('.filters_cars .header_filtre .part_filtre_one a').css('color', '#000');
      }

      compare_filtre = [];

      $('.filters_cars ul > li[data-sf-field-input-type="range-slider"]').each(function () {

        var test123 = $(this).children('div').children('label:first-child').children('input').val();
        var test321 = $(this).children('div').children('label:nth-child(3)').children('input').val();

        compare_filtre.push(test123);
        compare_filtre.push(test321);

      });


      if ((compare_filtre.indexOf(site_dicount_1) < 0 || compare_filtre.indexOf(site_dicount_2)) < 0) {
        $('.sf-meta-range.sf-meta-range-slider[data-sf-field-name="_sfm_site_discount_price"]').show().siblings('h4').addClass('active-filtre');

      }
      if ((compare_filtre.indexOf(year_param1) < 0 || compare_filtre.indexOf(year_param2)) < 0) {
        $('.sf-meta-range.sf-meta-range-slider[data-sf-field-name="_sfm_prod_year"]').show().siblings('h4').addClass('active-filtre');
      }
      if (compare_filtre.indexOf(tachometer_param_1) < 0 || compare_filtre.indexOf(tachometer_param_2) < 0 ) {
        $('.sf-meta-range.sf-meta-range-slider[data-sf-field-name="_sfm_tachometer_stat"]').show().siblings('h4').addClass('active-filtre');
      }
      $('.filters_cars .sf-field-sort_order .sf-input-select, .mobile_sort form ul li select').select2();

    });


    let url = window.location.href;
    if (url.includes('?')) {
      var site_discount_price_min = $('.sf-field-post-meta-site_discount_price .sf-meta-range.sf-meta-range-slider').attr('data-min');
      var site_discount_price_max = $('.sf-field-post-meta-site_discount_price .sf-meta-range.sf-meta-range-slider').attr('data-max');
      if (getParameterByName('_sfm_site_discount_price') != site_discount_price_min + ' ' + site_discount_price_max) {
        $('.sf-field-post-meta-site_discount_price .sf-meta-range.sf-meta-range-slider').show();
      }

      var site_prod_year_min = $('.sf-field-post-meta-prod_year .sf-meta-range.sf-meta-range-slider').attr('data-min');
      var site_prod_year_max = $('.sf-field-post-meta-prod_year .sf-meta-range.sf-meta-range-slider').attr('data-max');
      if (getParameterByName('_sfm_prod_year') != site_prod_year_min + ' ' + site_prod_year_max) {
        $('.sf-field-post-meta-prod_year .sf-meta-range.sf-meta-range-slider').show();
      }

      var site_km_min = $('.sf-field-post-meta-tachometer_stat .sf-meta-range.sf-meta-range-slider').attr('data-min');
      var site_km_max = $('.sf-field-post-meta-tachometer_stat .sf-meta-range.sf-meta-range-slider').attr('data-max');
      if (getParameterByName('_sfm_tachometer_stat') != site_km_min + ' ' + site_km_max) {
        $('.sf-field-post-meta-tachometer_stat .sf-meta-range.sf-meta-range-slider').show();
      }
      if ((window.location.search) == '?_sfm_site_discount_price=20000+250000&_sfm_prod_year=2015+2020&_sfm_tachometer_stat=0+132000' || (window.location.search) =='?_sfm_site_discount_price=34+174&_sfm_prod_year=2015+2020&_sfm_tachometer_stat=0+140000') {
        $('.filters_cars .header_filtre .part_filtre_one a').css('color', '#c0c0c0');
      } else {
        $('.filters_cars .header_filtre .part_filtre_one a').css('color', '#000');
      }
    }


    if (getParameterByName('_sfm_car_type') == 'new_car') {
      $('.new_car_select').removeClass('current_page_item');
      $('.new_car_item').addClass('current_page_item');
      $('.page-hero.lower_height').html('רכבים חדשים ');
    }




    $('.filters_cars .sf-field-sort_order .sf-input-select, .mobile_sort form ul li select').select2();

    /*Toggle Filtre Car*/

    $('.filters_cars').on('click', 'form h4', function () {
      $(this).toggleClass('active-filtre');
      $(this).next().toggle('slide');
    });

    $('.mobile_filters_cars .mobile_filtre').click(function () {

      $('.page-template-template-car-board .filters_cars').css({'width': '100%', 'opacity': '1', 'z-index': '333'});
      $('.page-template-template-car-board  .header-hero.col-12.container').fadeOut();

    });

    $('.header_filtre_mobile .cls_filtr').click(function () {
      $('.page-template-template-car-board .filters_cars').css({'width': '0', 'opacity': '0', 'z-index': '-3'});
      $('.page-template-template-car-board  .header-hero.col-12.container').fadeIn();

    });

    $('#search-filter-form-418 .sf-field-submit').click(function () {
      $('.page-template-template-car-board .filters_cars').css({'width': '0', 'opacity': '0', 'z-index': '-3'});
      $('.page-template-template-car-board  .header-hero.col-12.container').fadeIn();
      $("html, body").animate({scrollTop: 0}, "slow");
    });

    /* On submit of Filter Car */

    /* End Toggle Filtre Car*/

    /* rotate sort arrow*/
    $('span.select2-selection--single').on('click', function () {
      const label = $('li.sf-field-sort_order:last-child label');
      if (!label.hasClass('open')) {
        label.addClass('open')
      } else {
        label.removeClass('open');
      }
    })


    /*Disable reset click when no filter was selected*/
    $('.search-filter-reseting').on('click', function (e) {
      if ($(this).css('color') !== 'rgb(0, 0, 0)') {
        e.stopPropagation();
      }else{
        $(this).css('color','rgb(192, 192, 192)');
        if($('.page-hero').html() == "רכבים חדשים "){
          window.location.href = '/cars/?_sfm_car_type=new_car'
        }else{
          window.location.href = '/cars'
        }
      }
    })

    $('.title_car h3').each(function () {
      if (this.offsetWidth < this.scrollWidth && !$(this).attr('title')) {
        this.title = this.innerText;
      }

    })

    window.addEventListener('load', (event) => {
      checkParamsFilter()
    });

    function checkParamsFilter()
    {
      var carType = getParameterByName('_sfm_car_type');
      var carSegment = getParameterByName('_sft_segment_taxonomy');
      var carMarket = getParameterByName('_sft_car_market_taxonomy');
      var carYear = getParameterByName('_sfm_prod_year');

      if(carType){
        carType = carType.replaceAll('-','')
        carType = carType.replaceAll('new_car','רכב חדש')
        carType = carType.replaceAll('old_car','רכב מיד ראשונה')
      }
      if(carYear){
        carYear = carYear.replace(' ', '-');
      }

      var meta = getMetaText(carType, carSegment, carMarket, carYear)
      if(meta){
        $('title').text(meta.title);
        $('meta[name=description]').attr('content', meta.description);
        $('meta[property="og:title"]').attr('content', meta.title);
      }

    }


    function getMetaText(carType, carSegment, carMarket, carYear){

      if(carType && carSegment && carMarket && carYear){
        var text = JSON.parse(JSON.stringify(metaData[14]));
        text = replaceText(text, 'פרמטר#עסקה', carType)
        text = replaceText(text, 'פרמטר#הרכב', carSegment)
        text = replaceText(text, 'פרמטר#יצרן', carMarket)
        text = replaceText(text, 'פרמטר#שנה', carYear)
        return text;
      }

      if(carSegment && carMarket && carYear){
        var text = JSON.parse(JSON.stringify(metaData[13]));
        text = replaceText(text, 'פרמטר#הרכב', carSegment)
        text = replaceText(text, 'פרמטר#יצרן', carMarket)
        text = replaceText(text, 'פרמטר#שנה', carYear)
        return text;
      }

      if(carType && carMarket && carYear){
        var text = JSON.parse(JSON.stringify(metaData[12]));
        text = replaceText(text, 'פרמטר#עסקה', carType)
        text = replaceText(text, 'פרמטר#יצרן', carMarket)
        text = replaceText(text, 'פרמטר#שנה', carYear)
        return text;
      }

      if(carType && carSegment && carYear){
        var text = JSON.parse(JSON.stringify(metaData[11]));
        text = replaceText(text, 'פרמטר#עסקה', carType)
        text = replaceText(text, 'פרמטר#הרכב', carSegment)
        text = replaceText(text, 'פרמטר#שנה', carYear)
        return text;
      }

      if(carType && carSegment && carMarket){
        var text = JSON.parse(JSON.stringify(metaData[10]));
        text = replaceText(text, 'פרמטר#עסקה', carType)
        text = replaceText(text, 'פרמטר#הרכב', carSegment)
        text = replaceText(text, 'פרמטר#יצרן', carMarket)
        return text;
      }

      if(carMarket && carYear){
        var text = JSON.parse(JSON.stringify(metaData[9]));
        text = replaceText(text, 'פרמטר#יצרן', carMarket)
        text = replaceText(text, 'פרמטר#שנה', carYear)
        return text;
      }

      if(carSegment && carYear){
        var text = JSON.parse(JSON.stringify(metaData[8]));
        text = replaceText(text, 'פרמטר#הרכב', carSegment)
        text = replaceText(text, 'פרמטר#שנה', carYear)
        return text;
      }

      if(carSegment && carMarket){
        var text = JSON.parse(JSON.stringify(metaData[7]));
        text = replaceText(text, 'פרמטר#הרכב', carSegment)
        text = replaceText(text, 'פרמטר#יצרן', carMarket)
        return text;
      }

      if(carType && carYear){
        var text = JSON.parse(JSON.stringify(metaData[6]));
        text = replaceText(text, 'פרמטר#עסקה', carType)
        text = replaceText(text, 'פרמטר#שנה', carYear)
        return text;
      }

      if(carType && carMarket){
        var text = JSON.parse(JSON.stringify(metaData[5]));
        text = replaceText(text, 'פרמטר#עסקה', carType)
        text = replaceText(text, 'פרמטר#יצרן', carMarket)
        return text;
      }
      if(carType && carSegment){
        var text = JSON.parse(JSON.stringify(metaData[4]));
        text = replaceText(text, 'פרמטר#עסקה', carType)
        text = replaceText(text, 'פרמטר#הרכב', carSegment)
        return text;
      }

      if(carYear){
        var text = JSON.parse(JSON.stringify(metaData[3]));
        text = replaceText(text, 'פרמטר#שנה', carYear)
        return text;
      }

      if(carMarket){
        var text = JSON.parse(JSON.stringify(metaData[2]));
        text = replaceText(text, 'פרמטר#יצרן', carMarket)
        return text;
      }

      if(carSegment){
        var text = JSON.parse(JSON.stringify(metaData[1]));
        text = replaceText(text, 'פרמטר#הרכב', carSegment)
        return text;
      }

      if(carType){
        var text = JSON.parse(JSON.stringify(metaData[0]));
        text = replaceText(text, 'פרמטר#עסקה', carType)
        return text;
      }

      return null;

    }




    function replaceText(string, oldText, newText){
      string.title = string.title.replace(oldText, newText);
      string.description = string.description.replace(oldText, newText);
      return string;
    }




  },
};



// WEBPACK FOOTER //
// ./scripts/routes/cars.js